import httpApiApplication from '@/app/http/httpApiApplication';

import { type IdValue } from '../../TaxStatement/FormVersion/types';
import {
  type Disbursement,
  type DisbursementContent,
  type DisbursementStats,
  type DisbursementSummary
} from '../models/Disbursement';

export const disbursementService = {
  baseUrl: '/disbursement',

  listPendingDisbursement: async (): Promise<Array<Disbursement>> => {
    const response = await httpApiApplication.get<Array<Disbursement>>('disbursement/pending');

    return response;
  },

  getDisbursementStats: async (): Promise<DisbursementStats> => {
    const response = await httpApiApplication.get<DisbursementStats>('disbursement/stats');

    return response;
  },

  createDisbursement: async (values: DisbursementContent): Promise<IdValue> => {
    const id: IdValue = await httpApiApplication.post<IdValue>('/disbursement', values);

    return id;
  },

  getDisbursement: async (id: string): Promise<DisbursementSummary> => {
    const response = await httpApiApplication.get<DisbursementSummary>('disbursement/' + id);

    return response;
  }
};
